import React from "react";
import { useParams, Link } from "react-router-dom";
import "./EmptyHungryPage.scss";

const EmptyHungryPage = ({ text, showViewMenu = true }) => {
  const { restaurant, id, table } = useParams();
  return (
    <div className="empty-container">
      {/* <span
        animationData={emptyFoodAnimation}
        loop
        className="empty-animation"
      /> */}
      <h2>Hungry? Let’s get started</h2>
      <span
        className="empty-state plate"
        style={{ fontSize: "200px", color: "cadetblue" }}
      >
        🍽
      </span>

      {/* <span className="cutlery" style={{fontSize:"200px",color:"cadetblue"}}>🍴</span> */}

      <p>Add items from the menu to {text}</p>

      {showViewMenu && (
        <Link to={`/${restaurant}/${id}/${table}/menu`} className="empty-cta btn">
          View Menu
        </Link>
      )}
    </div>
  );
};

export default EmptyHungryPage;
